import { MapPolygon } from "@/ui/components/maps/common/interfaces/map-polygon";
import * as turf from '@turf/turf';

export const getCenterPointOfPolygon = (polygon: MapPolygon) => {
    let centerLt = 0;
    let centerLg = 0;

    polygon.coordinates[0].map(x => {
        centerLt += x[1];
        centerLg += x[0];
    });

    centerLg = centerLg / polygon.coordinates[0].length;
    centerLt = centerLt / polygon.coordinates[0].length;

    return { lat: centerLt, lon: centerLg };
}

export const isPointInGeofence = async (lat: number, lng: number, geofenceCoords: number[][]): Promise<boolean> => {
    const point = turf.point([lng, lat]);
    const polygon = turf.polygon([geofenceCoords]);

    const turfFunction = await import('@turf/turf');
    return turfFunction.booleanPointInPolygon(point, polygon);
}